<div class="container text-center py-4">
  <div class="d-flex justify-content-around align-items-center text-dark">
    <img src="../../assets/social media assets/footer-logo.svg" alt="logo"
      class="logo transform-rotate-90">
  </div>
  <p>{{subtitle}}</p>
  @if (title) {
    <h5 class="font-16 mb-3">{{title}}</h5>
  }
  <p><ngb-progressbar type="info" [animated]="true" height="3px" [value]="timer"></ngb-progressbar></p>
</div>
